// Números opcionales: un campo que puede quedar vacío, y vacío significa algo distinto de 0.
//
// El caso que lo motivó son los topes de las políticas de horas extras: vacío es «sin límite»
// y 0 es un límite real —con «Máx. días con HE» en 0, todas las horas pasan a triples desde el
// primer día—. MazInput con type="number" no sirve para esto: al vaciarse emite 0 por su
// cuenta, y además trunca con parseInt, así que 2.5 llega como 2 (ticket P3-I275). Esta regla
// vive aparte para que las dos cosas que importan —vacío ≠ 0 y los decimales se conservan— sean
// comprobables sin montar la pantalla.

// Texto capturado → número, o null si está vacío. Sólo acepta números no negativos, con
// punto o coma decimal. Lo que no se puede leer como tal también da null, y `valido` = false
// para que la pantalla pueda avisar en vez de guardar en silencio un «sin límite».
//
// `enteros`: rechaza decimales. Hace falta cuando el back declara el campo entero —p. ej.
// PoliticaHE.TopeDiasConHE es int?—, donde un 2.5 haría fallar el guardado entero.
export function aNumeroOpcional(texto, { enteros = false } = {}) {
  if (texto === null || texto === undefined) return { valor: null, valido: true };
  const patron = enteros ? /^\d+$/ : /^\d+(\.\d+)?$|^\.\d+$/;
  if (typeof texto === "number")
    return Number.isFinite(texto) && texto >= 0 && (!enteros || Number.isInteger(texto))
      ? { valor: texto, valido: true }
      : { valor: null, valido: false };
  const limpio = String(texto).trim().replace(",", ".");
  if (limpio === "") return { valor: null, valido: true };
  if (!patron.test(limpio)) return { valor: null, valido: false };
  return { valor: Number(limpio), valido: true };
}

// Número → texto para mostrar en el campo: null queda vacío, nunca «0».
export function aTextoOpcional(valor) {
  return valor === null || valor === undefined ? "" : String(valor);
}

export default { aNumeroOpcional, aTextoOpcional };
